import { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import Button from '@mui/material/Button';
import fnc from '../mymod/commFunction';
import TermsOfService from '../../../tailer_login/TermsOfService';
import PrivacyPolicy from '../../../tailer_login/PrivacyPolicy';
import './SignUpModal.scss';

const SignUpModal = ({ onClose, onLoginOpen }) => {
const [userId, setUserId] = useState('');
const [password, setPassword] = useState('');
const [passwordConfirm, setPasswordConfirm] = useState('');
const [email, setEmail] = useState('');
const [name, setName] = useState('');
const [phone, setPhone] = useState('');
const [certCode, setCertCode] = useState('');
const [couponCode, setCouponCode] = useState('');
const [authCode, setAuthCode] = useState('');

const [sentCode, setSentCode] = useState('');
const [sentTime, setSentTime] = useState(null);
const [phoneVerified, setPhoneVerified] = useState(true); // 테스트용: 인증 skip
const [sendCount, setSendCount] = useState(0);
const [isSending, setIsSending] = useState(false);
const [isVerifying, setIsVerifying] = useState(false);

const [agreeTerms, setAgreeTerms] = useState(false);
const [agreePrivacy, setAgreePrivacy] = useState(false);
const [agreeMarketing, setAgreeMarketing] = useState(false);
const [showTermsModal, setShowTermsModal] = useState(false);
const [showPrivacyModal, setShowPrivacyModal] = useState(false);

// ESC 키로 닫기
useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
}, [onClose]);

// 스크롤 잠금
useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
}, []);

const validateUserId = () => {
    if (!userId.trim()) { alert('아이디를 입력해주세요.'); return false; }
    if (!/^[a-zA-Z0-9]{4,20}$/.test(userId)) { alert('아이디는 영문, 숫자 조합으로 4-20자여야 합니다.'); return false; }
    return true;
};

const validatePassword = () => {
    if (!password) { alert('비밀번호를 입력해주세요.'); return false; }
    if (password.length < 8) { alert('비밀번호는 8자 이상이어야 합니다.'); return false; }
    if (!passwordConfirm) { alert('비밀번호 확인을 입력해주세요.'); return false; }
    if (password !== passwordConfirm) { alert('비밀번호가 일치하지 않습니다.'); return false; }
    return true;
};

const validatePhone = () => {
    if (!phone.trim()) { alert('핸드폰 번호를 입력해주세요.'); return false; }
    if (!/^01[0-9]{8,9}$/.test(phone)) { alert('올바른 핸드폰 번호를 입력해주세요.\n(예: 01012345678)'); return false; }
    return true;
};

const validateEmail = () => {
    if (!email.trim()) { alert('이메일을 입력해주세요.'); return false; }
    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) { alert('올바른 이메일 형식을 입력해주세요.'); return false; }
    return true;
};

const validateName = () => {
    if (!name.trim()) { alert('이름을 입력해주세요.'); return false; }
    if (name.length > 20) { alert('이름은 20자 이내로 입력해주세요.'); return false; }
    return true;
};

const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    setSentCode(''); setSentTime(null); setPhoneVerified(false); setCertCode('');
};

const handleSendCertCode = () => {
    if (!validateUserId() || !validatePassword() || !validatePhone() || !validateEmail()) return;
    if (sendCount >= 5) { alert('인증번호 전송 횟수를 초과했습니다 (최대 5회).\n페이지를 새로고침하고 다시 시도해주세요.'); return; }
    if (sentTime) {
    const elapsed = (Date.now() - sentTime) / 1000;
    if (elapsed < 60) { alert(`${Math.ceil(60 - elapsed)}초 후에 다시 시도해주세요.`); return; }
    }
    setIsSending(true);
    console.log('[SMS] 전송 시도:', '/signupRoutes/send-verification-sms', { phone, userId });
    fnc.sendAxios('/signupRoutes/send-verification-sms', { phone, userId }, (res) => {
    setIsSending(false);
    if (res.success) {
        setSentCode(res.code); setSentTime(Date.now()); setSendCount(prev => prev + 1);
        setPhoneVerified(false); setCertCode('');
        alert('인증번호가 전송되었습니다.\n5분 안에 입력해주세요.');
    } else { alert(res.message || '인증번호 전송에 실패했습니다.'); }
    });
};

const handleVerifyCertCode = () => {
    if (!sentCode || !sentTime) { alert('먼저 인증번호를 전송해주세요.'); return; }
    if ((Date.now() - sentTime) / 1000 > 300) {
    alert('인증번호가 만료되었습니다. 다시 전송해주세요.');
    setSentCode(''); setPhoneVerified(false); setCertCode(''); return;
    }
    if (certCode.trim() === sentCode) { setPhoneVerified(true); alert('핸드폰 인증이 완료되었습니다.'); }
    else { setPhoneVerified(false); alert('인증번호가 일치하지 않습니다.'); }
};

const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateUserId() || !validatePassword() || !validatePhone() || !validateEmail() || !validateName()) return;
    // if (!phoneVerified) { alert('핸드폰 인증이 필요합니다.'); return; } // 테스트용 주석 처리
    if (!authCode.trim()) { alert('인증코드를 입력해주세요.'); return; }
    if (!agreeTerms) { alert('이용약관에 동의해주세요.'); return; }
    if (!agreePrivacy) { alert('개인정보 처리방침에 동의해주세요.'); return; }
    if (!window.confirm(`아래 정보로 회원가입을 진행하시겠습니까?\n\n  아이디 : ${userId}\n  이름   : ${name}\n  핸드폰 : ${phone}\n  이메일 : ${email}`)) return;

    fnc.sendAxios('/signupRoutes/register',
    { userId, password, email, name, phone, couponCode: couponCode.trim(), authCode: authCode.trim(), agreeTerms, agreePrivacy, agreeMarketing },
    (res) => {
        if (res.success) {
        let msg = '회원가입이 완료되었습니다!';
        if (res.couponApplied) msg += `\n\n쿠폰 적용: ${couponCode}\n${res.couponMessage}`;
        else if (res.couponMessage) msg += `\n\n쿠폰 적용 실패: ${res.couponMessage}`;
        alert(msg);
        onClose();
        if (onLoginOpen) onLoginOpen();
        } else { alert(res.message || '회원가입에 실패했습니다.'); }
    }
    );
};

return createPortal(
    <div className="signup-modal-overlay" onClick={onClose}>
    <div className="signup-modal" onClick={(e) => e.stopPropagation()}>

        {/* 고정 헤더 */}
        <div className="modal-header-fixed">
        <p className="modal-title">AI 매쓰테일러 회원가입</p>
        <button className="btn-close" type="button" onClick={onClose} aria-label="닫기">✕</button>
        </div>

        {/* 스크롤 영역 */}
        <form onSubmit={handleSubmit} noValidate>
        <div className="modal-scroll-body">
            <div className="field">
            <label htmlFor="su-authCode">*학원코드</label>
            <input id="su-authCode" type="text" value={authCode} onChange={(e) => setAuthCode(e.target.value)} placeholder="학원코드를 입력해 주세요." />
            </div>

            <div className="field">
            <label htmlFor="su-userId">*아이디</label>
            <input id="su-userId" type="text" value={userId} onChange={(e) => setUserId(e.target.value)} placeholder="영문, 숫자 4-20자" />
            </div>

            <div className="field">
            <label htmlFor="su-password">*비밀번호</label>
            <input id="su-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="8자 이상" />
            </div>

            <div className="field">
            <label htmlFor="su-passwordConfirm">*비밀번호 확인</label>
            <input id="su-passwordConfirm" type="password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} placeholder="비밀번호 재입력" />
            </div>

            <div className="field">
            <label htmlFor="su-email">*이메일</label>
            <input id="su-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="example@email.com" />
            </div>

            <div className="field">
            <label htmlFor="su-name">*이름</label>
            <input id="su-name" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="이름 입력" />
            </div>

            <div className="field">
            <label htmlFor="su-phone">*핸드폰</label>
            <div className="input-with-button">
                <input id="su-phone" type="text" value={phone} onChange={handlePhoneChange} placeholder="01012345678" className="phone-input" />
                <Button variant="contained" className="cert-send-btn" onClick={handleSendCertCode} disabled={isSending}>
                {isSending ? '전송중...' : '인증전송'}
                </Button>
            </div>
            </div>

            <div className="field">
            <label htmlFor="su-certCode">*인증번호</label>
            <div className="input-with-button">
                <input id="su-certCode" type="text" value={certCode} onChange={(e) => setCertCode(e.target.value)} placeholder="인증번호 6자리" disabled={!sentCode} className={`cert-input ${phoneVerified ? 'verified' : ''}`} />
                <Button variant="contained" className="cert-verify-btn" onClick={handleVerifyCertCode} disabled={!sentCode || isVerifying}>확인</Button>
            </div>
            </div>

            <div className="field">
            <label htmlFor="su-couponCode">쿠폰코드 (선택사항)</label>
            <input id="su-couponCode" type="text" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} placeholder="쿠폰코드 입력" />
            </div>

            <div className="terms-agreement">
            <div className="checkbox-row">
                <input type="checkbox" id="su-agreeTerms" checked={agreeTerms} onChange={(e) => setAgreeTerms(e.target.checked)} />
                <label htmlFor="su-agreeTerms">
                <span className="required">[필수]</span> 이용약관 동의
                <span className="view-link" onClick={() => setShowTermsModal(true)}>보기</span>
                </label>
            </div>
            <div className="checkbox-row">
                <input type="checkbox" id="su-agreePrivacy" checked={agreePrivacy} onChange={(e) => setAgreePrivacy(e.target.checked)} />
                <label htmlFor="su-agreePrivacy">
                <span className="required">[필수]</span> 개인정보 처리방침 동의
                <span className="view-link" onClick={() => setShowPrivacyModal(true)}>보기</span>
                </label>
            </div>
            <div className="checkbox-row">
                <input type="checkbox" id="su-agreeMarketing" checked={agreeMarketing} onChange={(e) => setAgreeMarketing(e.target.checked)} />
                <label htmlFor="su-agreeMarketing">[선택] 마케팅 정보 수신 동의</label>
            </div>
            <div className="checkbox-row all-agree">
                <input type="checkbox" id="su-agreeAll"
                checked={agreeTerms && agreePrivacy && agreeMarketing}
                onChange={(e) => { setAgreeTerms(e.target.checked); setAgreePrivacy(e.target.checked); setAgreeMarketing(e.target.checked); }}
                />
                <label htmlFor="su-agreeAll">전체 동의</label>
            </div>
            </div>
        </div>

        {/* 고정 푸터 */}
        <div className="modal-footer-fixed">
            <Button variant="contained" className="btnSignUp" type="submit">회원가입</Button>
            <Button variant="outlined" className="btnCancel" type="button" onClick={onClose}>취소</Button>
        </div>
        </form>

        {showTermsModal && (
        <div className="terms-modal" onClick={() => setShowTermsModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
                <h3>이용약관</h3>
                <button className="close-btn" onClick={() => setShowTermsModal(false)}>×</button>
            </div>
            <div className="modal-body"><TermsOfService /></div>
            <div className="modal-footer"><button onClick={() => setShowTermsModal(false)}>닫기</button></div>
            </div>
        </div>
        )}

        {showPrivacyModal && (
        <div className="terms-modal" onClick={() => setShowPrivacyModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
                <h3>개인정보 처리방침</h3>
                <button className="close-btn" onClick={() => setShowPrivacyModal(false)}>×</button>
            </div>
            <div className="modal-body"><PrivacyPolicy /></div>
            <div className="modal-footer"><button onClick={() => setShowPrivacyModal(false)}>닫기</button></div>
            </div>
        </div>
        )}
    </div>
    </div>,
    document.body
);
};

export default SignUpModal;
